import React from 'react';

export default class clock extends React.Component {
  constructor(props) {
    super(props);

    let time = new Date();
    let month = '';
    switch (time.getMonth()) {
      case 0:
        month = 'Jan';
        break;
      case 1:
        month = 'Feb';
        break;
      case 2:
        month = 'Mar';
        break;
      case 3:
        month = 'Apr';
        break;
      case 4:
        month = 'May';
        break;
      case 5:
        month = 'Jun';
        break;
      case 6:
        month = 'Jul';
        break;
      case 7:
        month = 'Aug';
        break;
      case 8:
        month = 'Sept';
        break;
      case 9:
        month = 'Oct';
        break;
      case 10:
        month = 'Nov';
        break;
      case 11:
        month = 'Dec';
        break;
      default:
        console.log('Clock case default');
    }

    function pad(n) {
      return n < 10 ? '0' + n : n;
    }

    let hours = time.getHours();
    let minutes = time.getMinutes();
    let amPm = 'AM';

    if (hours > 12) {
      hours -= 12;
      amPm = 'PM';
    } else if (hours === 0) {
      hours = 12;
    }

    let todisplay = hours + ':' + pad(minutes) + ' ' + amPm;

    this.state = {
      time: todisplay,
      curDate: month + ' ' + time.getDate()
    };
  }

  componentDidMount() {
    this.intervalID = setInterval(() => this.tick(), 10000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  tick() {
    function pad(n) {
      return n < 10 ? '0' + n : n;
    }

    let time = new Date();
    let hours = time.getHours();
    let minutes = time.getMinutes();
    let amPm = 'AM';

    if (hours > 12) {
      hours -= 12;
      amPm = 'PM';
    } else if (hours === 0) {
      hours = 12;
    }

    let todisplay = hours + ':' + pad(minutes) + ' ' + amPm;

    this.setState({
      time: todisplay
    });
  }

  render() {
    return (
      <div className="clock">
        <p className="App-clock">{this.state.time}</p>
        <p className="App-date">{this.state.curDate}</p>
      </div>
    );
  }
}
